import React, { useEffect, useState } from 'react';
import { Filter, X } from 'lucide-react';
import { loadProjectNodes } from '../lib/constructionCache';

// Reusable construction-context filter (Building / Floor / Zone / Trade / Activity).
const FILTERS = [
  { field: 'buildingId', label: 'Building', source: (d) => d.locations.filter((l) => l.kind === 'building') },
  { field: 'floorId', label: 'Floor', source: (d) => d.locations.filter((l) => l.kind === 'floor') },
  { field: 'zoneId', label: 'Zone', source: (d) => d.locations.filter((l) => l.kind === 'zone') },
  { field: 'tradeId', label: 'Trade', source: (d) => d.trades },
  { field: 'activityId', label: 'Activity', source: (d) => d.activities },
];

const ConstructionContextFilter = ({ projectId, value, onChange, testId = 'context-filter' }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    let active = true;
    loadProjectNodes(projectId).then((d) => { if (active) setData(d); });
    return () => { active = false; };
  }, [projectId]);

  if (!data) return null;

  const available = FILTERS.map((f) => ({ ...f, options: f.source(data) })).filter((f) => f.options.length > 0);
  if (available.length === 0) return null;

  const set = (field, val) => {
    const next = { ...(value || {}) };
    if (val) next[field] = val; else delete next[field];
    onChange(next);
  };
  const active = value && Object.keys(value).length > 0;

  return (
    <div className="flex items-center flex-wrap gap-2 bg-white border border-slate-200 rounded-lg px-3 py-2" data-testid={testId}>
      <Filter className="w-4 h-4 text-slate-400" />
      {available.map((f) => (
        <select
          key={f.field}
          value={(value || {})[f.field] || ''}
          onChange={(e) => set(f.field, e.target.value)}
          className="px-2 py-1 border border-slate-300 rounded text-xs bg-white"
          data-testid={`${testId}-${f.field}`}
        >
          <option value="">{f.label}: All</option>
          {f.options.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
        </select>
      ))}
      {active && (
        <button onClick={() => onChange({})} className="text-xs text-slate-400 hover:text-red-500 flex items-center gap-1" data-testid={`${testId}-clear`}>
          <X className="w-3 h-3" /> Clear
        </button>
      )}
    </div>
  );
};

export default ConstructionContextFilter;
